import { Container, Modal, Typography } from '@cleartrip/ct-design-components'
import React, { useEffect, useState } from "react";

import { ravenSDKHomeTrigger } from '@/analytics/raven/ravenSDKHelper'
import VdcEducationPage from '@/components/itinerary/Review/VdcBanner/VdcEducationPage/index'
import useInView from '@/utils/hooks/useInView'
import VisaDenialLogo from "src/assets/svg/VisaDenialLogo.js"; 

interface VisaDenialBannerProps {
    isHomePage?: boolean
}

function VisaBanner({ isHomePage = false}: VisaDenialBannerProps) {
    const [showPopup, setShowPopup] = useState(false)
    const [shouldAnimate, setShouldAnimate] = useState(false)

    useEffect(() => {
        if (isHomePage) {
            ravenSDKHomeTrigger('a_merch_widget_impression', {
                action_name: 'merch_impression',
                object_id: 'visadenial_banner',
                url: 'www.cleartrip.com/lp/visa-denial',
                src: 'n/a'
            })
        }
    }, [])

    const { ref } = useInView({
      triggerOnce: true,
      skip: !isHomePage,
      onChange: (inView) => {
          if (inView && isHomePage) {
              ravenSDKHomeTrigger('a_merch_widget_view', {
                  action_name: 'merch_view',
                  object_id: 'visadenial_banner',
                  url: 'www.cleartrip.com/lp/visa-denial',
                  src: 'n/a'
              })
              setShouldAnimate(true)
          }
      }
  })
  
    const handleBannerClick = () => {
      if (isHomePage) {
          ravenSDKHomeTrigger('a_merch_widget_click', {
              action_name: 'merch_click',
              object_id: 'visadenial_banner',
              url: 'www.cleartrip.com/lp/visa-denial',
              src: 'n/a'
          })
      }
      setShowPopup(true)
  }
    return ( <>
        <Container 
          ref={ref as unknown as React.RefObject<HTMLDivElement>} 
          className='p-relative'
          style={{ 
            top: '-10px',
            maxHeight: shouldAnimate ? '200px' : '0px',
            overflow: shouldAnimate ? 'visible' : 'hidden',
            transition: 'max-height 1.5s ease-in-out, opacity 1.5s ease-in-out',
            opacity: shouldAnimate ? 1 : 0,
           }}
        >
            <Container 
              className='flex flex-middle flex-center p-relative'
              style={{
                borderRadius: '0 0 16px 16px',
                color: '#1a1a1a',
                backgroundColor: '#efe3ff',
                padding: '12px 8px 7px',
                height:'69px',
                gap: '12px'
              }}
            >
              <Container className="flex flex-middle">
              <VisaDenialLogo width={18} height={22} />
              </Container>
              <Typography variant="B1">
               Visa Rejection Cover available. Get full fare refund if your visa gets rejected!
              <span className="c-pointer" style={{color: '#0F6BFF' , marginLeft: '8px'}} onClick={() => handleBannerClick()}> Learn more </span>
              </Typography> 
            </Container>
        </Container>
      <Modal 
        allowBackdropClose 
        hideCrossIcon={false} 
        modalContentCss={{ 
          width: '100%',
          borderRadius: '32px 32px 0 0',
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          height: '93vh'
        }} 
        open={showPopup}  
        onClose={() => setShowPopup(false)} 
      >
        <VdcEducationPage onClose={() => setShowPopup(false)} />
      </Modal>
    </>
  );
}

export default VisaBanner;
